/**
 * Create Raid HTTP Service
 *
 * Calls the create-raid endpoint to initiate a new raid lobby.
 */

import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { CreateRaidInput, CreateRaidOutput } from "types/web-app";

/**
 * Create a new raid lobby
 */
export const createRaid = async (
  accessToken: string,
  input: CreateRaidInput,
): Promise<ServiceResponse<CreateRaidOutput>> => {
  try {
    const response = await fetchWithAuth("/raid/create", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });

    return (await response.json()) as ServiceResponse<CreateRaidOutput>;
  } catch (error) {
    console.error("Error creating raid:", error);
    throw error;
  }
};
